<template>
<div class="row">
    <div class="col-xl-5 col-lg-5 col-12 mb-3">
        <div class="mb-3">
            <div class="input-group">
                <span class="input-group-text w3-light-gray">Titulo:</span>
                <input type="text" class="form-control form-control-sm" v-model="titulo" maxlength="100" :class="titulo.length ? 'is-valid': 'is-invalid'" />
                <div class="invalid-feedback ms-2">Este campo es obligatorio!!</div>
            </div>
            <small class="float-end me-2">{{ titulo.length }}/100</small>
        </div>
    </div>
    <div class="col-xl-5 col-lg-5 col-12 mb-3">
        <div class="mb-3">
            <div class="input-group">
                <span class="input-group-text w3-light-gray">Texto:</span>
                <input type="text" class="form-control form-control-sm" v-model="texto" maxlength="100" :class="texto.length ? 'is-valid': 'is-invalid'" />
                <div class="invalid-feedback ms-2">Este campo es obligatorio!!</div>
            </div>
            <small class="float-end me-2">{{ texto.length }}/100</small>
        </div>
    </div>
    <div class="col-xl-2 col-lg-2 col-12 mb-3 text-center">
        <button type="button" class="btn btn-danger px-2" @click.prevent="$delItem($index)">
            <i class="fas fa-backspace fa-lg me-2"></i>
            <span>Quitar</span>
        </button>
    </div>
</div>
</template>

<script>
export default {
    props: {
        $delItem: Function,
        $index: Number,
        $createRegister: Function,
        $info: Object,
        $id: String,
    },
    created() {
        this.titulo = this.$info.titulo;
        this.texto = this.$info.texto;
        this.debouncedCreateRegister = _.debounce(this.createRegister, 500);
    },
    watch: {
        $id() {
            this.titulo = this.$info.titulo;
            this.texto = this.$info.texto;
        },
        titulo() {
            this.debouncedCreateRegister();
        },
        texto() {
            this.debouncedCreateRegister();
        },
    },
    data() {
        return {
            titulo: '',
            texto: '',
        }
    },
    methods: {
        createRegister() {
            this.$createRegister(this.$index, this.titulo, this.texto);
        },
    },
}
</script>
